export default __webpack_public_path__ + "static/media/img_placeholder.d07f0599.png";